import React from 'react'
import PlacePresenter from './PlacePresenter'

import FlexGrid from '../../components/structure/FlexGrid'
import { COLORS } from '@btime/constants'
import { HorizontalLine } from '../../components/shapes/Line'
import Separator from '../../components/helpers/Separator'

const PlacesList = ({ items, ...props }) => {
  return (
    <div>
      <FlexGrid direction="column" gutter={0.2} align="stretch">
        {items.map((item, index) => (
          <div key={item.id}>
            {index !== 0 && <HorizontalLine thin lineColor={COLORS.light2} />}
            <Separator />
            <PlacePresenter key={item.id} place={item} {...props} />
            <Separator />
          </div>
        ))}
      </FlexGrid>
    </div>
  )
}

export default PlacesList
